import styled, { css } from 'styled-components';
import { getStyle } from '@utils/style';
import { DynamicTypography } from '@components/DynamicTypography';

export interface ButtonProps {
  title: string;
  type: 'primary' | 'secondary';
  disabled?: boolean;
  icon?: React.ReactNode;
  onClick: () => void;
  isLoading?: boolean;
  style?: React.CSSProperties;
}

interface StyledButtonProps {
  $type: 'primary' | 'secondary';
  $isLoading?: boolean;
  $disabled?: boolean;
  $hasIcon?: boolean;
}

const StyledButton = styled.button<StyledButtonProps>`
  font-size: ${() => (window.innerWidth < 800 ? '14px' : getStyle('BUTTON_FONT_SIZE', true))};
  height: ${() => (window.innerWidth < 800 ? '40px' : getStyle('BUTTON_HEIGHT', true))};
  opacity: ${(props) => (props.$isLoading ? 0.8 : 1)};
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 4px;
  border: 1px solid;
  cursor: pointer;
  padding: 10px 0;
  display: flex;
  outline: none;
  width: 100%;

  ${(props) =>
    props.$type === 'primary' &&
    css`
      background-color: ${getStyle('BUTTON_PRIMARY_BACKGROUND', true)};
      color: ${getStyle('BUTTON_PRIMARY_TEXT_COLOR', true)};
      border-color: ${getStyle('BUTTON_PRIMARY_BORDER', true)};
    `}

  ${(props) =>
    props.$type === 'secondary' &&
    css`
      background-color: ${getStyle('BUTTON_SECONDARY_BACKGROUND', true)};
      color: ${props.$hasIcon
        ? getStyle('PRIMARY_COLOR', true)
        : getStyle('BUTTON_SECONDARY_TEXT_COLOR', true)};
      border-color: ${getStyle('BUTTON_SECONDARY_BORDER', true)};
    `}
  
  ${(props) =>
    props.$disabled &&
    css`
      background-color: ${getStyle('BUTTON_DISABLED_BACKGROUND', true)};
      color: ${getStyle('BUTTON_DISABLED_TEXT_COLOR', true)};
      border-color: ${getStyle('BUTTON_DISABLED_BORDER', true)};
    `}
   
   svg {
    margin-right: 5px;
    color: ${getStyle('PRIMARY_COLOR', true)};
  }
`;

export const Button = ({ type, disabled, icon, onClick, style, title, isLoading }: ButtonProps) => {
  return (
    <StyledButton
      $type={type}
      $disabled={disabled}
      $hasIcon={!!icon}
      $isLoading={isLoading}
      disabled={disabled}
      onClick={onClick}
      style={style}
    >
      {icon}
      <DynamicTypography content={title} component={'span'} />
    </StyledButton>
  );
};
